import React from 'react';
import { useHistory } from 'react-router-dom';
import noWaves from 'assets/images/noWaves.png';
import {
	ApButtonMain,
	ApButtonTab,
	ApSecondaryNav,
} from '@alixpartners/ui-components';
import { Container, MainMessage } from './styles';
import { PLAN_AND_TRACK_NAV_CONFIG } from 'Waves/constants';
import { NavLink, useLocation } from 'react-router-dom';

const NoAllocatedInitiatives = () => {
	const history = useHistory();
	const location = useLocation();
	return (
		<>
			<ApSecondaryNav
				left={PLAN_AND_TRACK_NAV_CONFIG.map(({ label, path, disabled }) => (
					<NavLink to={path} key={path} disabled={disabled}>
						<ApButtonTab
							isSelected={location.pathname === path}
							disabled={disabled}
						>
							{label}
						</ApButtonTab>
					</NavLink>
				))}
			/>
			<Container>
				<img src={noWaves} alt="no initiatives" width={370} />
				<MainMessage>Plan the execution of your initiatives</MainMessage>
				<ApButtonMain
					iconName="waves"
					onClick={() => {
						history.push('/waves/allocate');
					}}
				>
					allocate initiatives
				</ApButtonMain>
			</Container>
		</>
	);
};

export default NoAllocatedInitiatives;
